import React, { Component } from 'react';
// import { Link } from 'react-router';
import Header from '../../components/Header';
import withGoBack from '../../common/withGoBack';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withOnline from '../../common/withOnline';
import withTableName from '../../common/withTableName';
import {
  onGoBack,
  getSelectedTeamName
} from '../../common/globals';
import {
  caseDgrsList,
  uploadDgr,
  removeDgr,
  generateTimedURL,
  listSingleCase,
  updateCase
} from '../../utils/utils';
import withUser from '../../common/withUser';
import {
  updateTableWiseCaseByCaseId,
  updateTableCaseByPrimaryId,
  getTableCaseByCaseId,
  getTeams
} from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
import SelectFileOrTakePhoto from '../../components/Models/SelectFileOrTakePhoto';
import CaseChangesNoLonger from '../../components/Models/CasesChangesNoLonger';
import DGRDelete from '../../components/Models/DGRDelete';
import withProducts from '../../common/withProducts';
import DGROpenCamera from '../../components/Models/DGROpenCamera';
import withBrowserDetect from '../../common/withBrowserDetect';
import withReadOnlyProductNotes from '../../common/withReadOnlyProductNotes';

class Dgr extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DRGLists: [],
      DGRData: {},
      DGR: '',
      DRRCameraStatue: false
    };
    // this.selectFileOrTakePhoto = null;
    // this.takePhotoModal = null;
    this.caseChangesNoLonger = null;
    this.DGRDelete = null;
    this.DGROpenCarmera = null;
  }

  componentDidMount() {
    try {
      const { readOnlyProductNotes } = this.props;
      // this.selectFileOrTakePhoto =
      // new window.bootstrap.Modal(window.$('#selectFileOrTakePhoto'));
      // this.takePhotoModal = new window.bootstrap.Modal(window.$('#takePhotoModal'));
      this.caseChangesNoLonger = new window.bootstrap.Modal(window.$('#CaseChangesNoLongerModal'));
      this.DGRDelete = new window.bootstrap.Modal(window.$('#DGRDeleteModal'));

      this.DGROpenCarmera = new window.bootstrap.Modal(window.$('#DGROpenCameraModal'));

      if (!readOnlyProductNotes) {
        this.DGROpenCarmera.show();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectImage = async (formData) => {
    try {
      const {
        setLoader, notify, online, params: { id }, tableName, products
      } = this.props;

      const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
      const body = formData.files[0];

      if (!(/\.(gif|jpg|jpeg|tiff|png|pdf|heic)$/i).test(body.name)) {
        notify({ type: 'error', message: 'Only images and PDF files are allowed for DGR uploads.' });
        return;
      }

      setLoader(true);
      if (online) {
        // this.selectFileOrTakePhoto.hide();
        // this.takePhotoModal.hide();
        this.setState({ DRRCameraStatue: false });

        uploadDgr({
          CaseScheduleID: caseDetailsRes.CaseScheduleID,
          OriginalFile: body
        }).then(async (responseJson) => {
          setLoader(false);
          const {
            message, data, result
          } = responseJson;
          if (result === 'success') {
            if (message.length > 0) {
              // notify({ type: 'success', message });
            }
            // Update into local db
            caseDetailsRes.case_dgrs.push(data);
            caseDetailsRes.DGRUpload = '2';
            // caseDetailsRes.ProductSubmitted = '0';
            // caseDetailsRes.ProductNotes = (
            //   caseDetailsRes.ProductNotes === ''
            //   || caseDetailsRes.ProductNotes === null
            //   || caseDetailsRes.ProductNotes === 'No products used'
            // ) ? '' : caseDetailsRes.ProductNotes;

            if (
              typeof caseDetailsRes.ProductNotes !== 'undefined'
              && (caseDetailsRes.ProductNotes === '' || caseDetailsRes.ProductNotes === null)
            ) {
              // caseDetailsRes.ProductNotes = 'No products used';
              if (products.length === 1) {
                caseDetailsRes.ProductNotes = 'No products used';
              }
            }

            delete caseDetailsRes.FFFDate;
            delete caseDetailsRes.FFFRep;
            delete caseDetailsRes.FFFValue;

            await updateCase(caseDetailsRes);
            await updateTableWiseCaseByCaseId(caseDetailsRes.RepCaseNo, caseDetailsRes, tableName);
            this._getDGRLists();
          } else if (result === 'failure') {
            notify({ type: 'error', message });
          } else {
            notify({ type: 'error', message });
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _getDGRLists = async () => {
    try {
      const {
        notify, setLoader, online, params: { id }, tableName
      } = this.props;
      const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
      if (online) {
        setLoader(true);
        caseDgrsList(caseDetailsRes.CaseScheduleID).then(async (responseJson) => {
          const { status, message, data } = responseJson;
          if (status) {
            const sortDGRRes = data !== undefined ? data.sort((a, b) => a - b).reverse() : [];
            responseJson = await listSingleCase(caseDetailsRes.CaseScheduleID);
            const caseDetails = responseJson.data[0];
            caseDetails.id = parseInt(caseDetailsRes.id, 10);
            caseDetails.CaseDate = caseDetailsRes.CaseDate;
            caseDetails.CaseTime = caseDetailsRes.CaseTime;
            // Update into local db
            await updateTableWiseCaseByCaseId(
              caseDetails.id, caseDetails, tableName
            );
            this.setState({ DRGLists: sortDGRRes });
            setLoader(false);
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        setLoader(true);
        // Get the DRGLists list if user is offline
        const data = caseDetailsRes.case_dgrs;
        const sortDGRRes = data !== undefined ? data.sort((a, b) => a - b).reverse() : [];
        this.setState({ DRGLists: sortDGRRes });
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onOpenDGRDeletePopup = (data) => {
    try {
      this.setState({
        DGRData: data
      });
      this.DGRDelete.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveDGR = async (data) => {
    try {
      const {
        notify, setLoader, params: { id }, tableName
      } = this.props;
      const teams = await getTeams();
      const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
      setLoader(true);
      removeDgr(data.DGRID).then(async (responseJson) => {
        const { status, message } = responseJson;
        if (status) {
          // notify({ type: 'success', message });
          if ((caseDetailsRes.case_dgrs.length - 1) === 0) {
            if (teams[0].DGRRequired === '6') {
              caseDetailsRes.DGRUpload = '1';
            } else {
              caseDetailsRes.DGRUpload = '0';
            }
            caseDetailsRes.ProductSubmitted = '0';
            await updateCase(caseDetailsRes);
          }
          const singleCaseRes = await listSingleCase(caseDetailsRes.CaseScheduleID);

          singleCaseRes.data[0].CaseDate = caseDetailsRes.CaseDate;
          singleCaseRes.data[0].CaseTime = caseDetailsRes.CaseTime;
          await updateTableCaseByPrimaryId(caseDetailsRes.id, singleCaseRes.data[0], tableName);
          await this._getDGRLists();
          setLoader(false);
        } else {
          notify({ type: 'error', message });
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _openImage = async (DGRId) => {
    try {
      const {
        user, setLoader, notify, online
      } = this.props;
      if (online) {
        const generateTimedURLData = {
          team: await getSelectedTeamName(),
          entity_type: 'dgrs',
          entity_id: DGRId,
          token: user.token,
          key: user.userKey
        };
        setLoader(true);
        generateTimedURL(generateTimedURLData).then((responseJson) => {
          setLoader(false);
          const { status, message, data } = responseJson;
          if (status) {
            if (message.length > 0) {
              // notify({ type: 'success', message });
            }
            window.open(data, '', 'width=900, height=900');
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectImageFile = () => {
    try {
      this.selectFileOrTakePhoto.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCopyDgr = async (dgrData) => {
    const {
      online, notify, user, setLoader
    } = this.props;
    try {
      if (online) {
        const generateTimedURLData = {
          team: await getSelectedTeamName(),
          entity_type: 'dgrs',
          entity_id: dgrData.DGRID,
          token: user.token,
          key: user.userKey
        };
        setLoader(true);
        generateTimedURL(generateTimedURLData).then((responseJson) => {
          setLoader(false);
          const { status, message, data } = responseJson;
          if (status) {
            navigator.clipboard.writeText(data);
            notify({ type: 'success', message: 'URL Copied' });
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getCaseDgrValue = async () => {
    const { params: { id }, tableName } = this.props;
    const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
    this.setState({ DGR: caseDetailsRes.DGR });
  }

  _onOpenDgr = () => {
    this.setState({ DRRCameraStatue: true }, () => {
      document.getElementById('uploadDGREle1').click();
    });
  }

  UNSAFE_componentWillMount() {
    try {
      this._getDGRLists();
      this._getCaseDgrValue();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { goBack, params: { id }, browserDetect } = this.props;
    const {
      DRGLists, DGRData, DGR, DRRCameraStatue
    } = this.state;

    return (
      <div className="site-wrapper">
        <Header
          actionButton={{
            type: 'button',
            title: 'Upload',
            onClick: () => {
              document.getElementById('uploadDGREle').click();
            }
          }}
          title="DGRs"
          goBack={() => onGoBack(goBack)}
        />
        <section className="xrays-section">
          <input
            id="uploadDGREle"
            type="file"
            accept="image/*,.pdf"
            onChange={(e) => this._onSelectImage(e.target)}
            className="d-none"
          />

          <input
            id="uploadDGREle1"
            type="file"
            accept="image/*,.pdf"
            onChange={(e) => this._onSelectImage(e.target)}
            className="d-none"
            {...(browserDetect === 'Safari' && DRRCameraStatue ? { capture: 'environment' } : {})}
          />

          {/* <Link
            data-bs-toggle="modal"
            data-bs-target="#selectFileOrTakePhoto"
          >
            <input
              type="file"
              id="fileControl"
              className="d-none"
            />
          </Link> */}

          <div className="container">
            <div className="xrays-block">
              <div className="row">
                <div className="col-12">
                  <p className="text-start">{DRGLists !== undefined ? `DGRs: ${DRGLists.length}` : 'DGRs: 0'}</p>
                  {
                    (DRGLists.length > 0)
                      ? DRGLists.map((data, key) => (

                        <ul className="list-unstyled xrays-list mb-0" key={key}>
                          <li className="d-flex cursor-pointer">
                            <div className="col-10 col-md-10" onClick={() => this._openImage(data.DGRID)}>
                              {`DGRs: ${data.DGRNo}`}
                            </div>
                            <div className="col-2 col-md-2">
                              {
                                DGR === '0' && (
                                  <button
                                    className="btn btn-icon"
                                    onClick={() => this._onOpenDGRDeletePopup(data)}
                                  ><i className="fas fa-trash" />
                                  </button>
                                )
                              }
                              <button
                                className="btn btn-icon ms-0"
                                onClick={
                                  () => this._onCopyDgr(data)
                                }
                              ><i className="fas fa-copy" />
                              </button>
                            </div>
                          </li>
                        </ul>
                      )) : ''
                  }
                </div>
              </div>
            </div>
          </div>
          <SelectFileOrTakePhoto
            onSelectImage={this._onSelectImage} onTakePhoto={this._onSelectImage}
          />
          <CaseChangesNoLonger
            id={id}
          />
          <DGRDelete
            DGRData={DGRData}
            onDeleteDgr={this._onRemoveDGR}
          />
          <DGROpenCamera
            onOpenDgr={this._onOpenDgr}
          />
        </section>
      </div>
    );
  }
}

export default withTableName(
  withOnline(
    withUser(
      withLoader(
        withNotify(
          withGoBack(
            withProducts(
              withBrowserDetect(
                withReadOnlyProductNotes(
                  Dgr
                )
              )
            )
          )
        )
      )
    )
  )
);
